<template>
  <section role="main" class="content-body">
    <header class="page-header">
      <h2>預算分配</h2>
      <div class="right-wrapper">
        <ol class="breadcrumbs">
          <li>
            <a href="/">
              <i class="fa fa-home"></i>
            </a>
          </li>
          <li><span>預算分配</span></li>
          <li><span>擴增預算</span></li>
        </ol>
      </div>
    </header>
    <!-- start: page -->
    <div id="tabs-02" class="row">
      <div id="tabs-04" class="row">
        <div class="col-md-12">
          <section class="panel">
            <header class="panel-heading">
              <h2 class="panel-title">擴增預算/紀錄</h2>
            </header>
            <div class="panel-body">
              <div align="left">　
                單位/系所代碼：{{info.deptCode}}
              </div>
              <div align="left">　
                單位/系所名稱：<span style="color:#FF0000;">{{info.deptName}} </span>
              </div>
              <div align="left">　
                剩餘金額：<span style="color:#FF0000;">{{info.remainingBudget | numberWithCommas}} </span>
              </div><br>
              <div align="left">　
                擴充金額：<input type="number" v-model="form.expansionMoney">　　　備註說明：<input type="text" v-model="form.expansionRemark">　
                　 <a href="#" @click.prevent="formSubmit" class="btn-upload btn btn-primary" style="background-color:#337AB7; border-color:#2E6DA4;">送出</a>　
              </div>
              <div class="s_tenr">
                <table class="table table-no-more table-bordered table-striped mb-none">
                  <thead>
                    <tr>
                      <th class="text-center" width="13%">擴充日期</th>
                      <th class="text-center" width="14%">擴充金額</th>
                      <th class="text-center" width="43%">備註說明</th>
                      <th class="text-center" width="13%">擴充者帳號</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, index) in list" :key="index">
                      <td data-title="擴充日期" class="text-center">{{item.createDate}}</td>
                      <td data-title="擴充金額" class="text-center">{{item.expansionMoney | numberWithCommas}}</td>
                      <td data-title="備註說明" class="text-center">{{item.expansionRemark}}</td>
                      <td data-title="擴充者帳號" class="text-center">{{item.createUser}}</td>
                    </tr>
                  </tbody>
                </table>
                <div align="center">
                  <br><router-link to="/budget" class="btn-upload btn btn-primary" style="background-color:#9e9e9e; border-color:#858484;">返回</router-link>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  data() {
    return {
      info: {
        deptCode: null,
        deptName: null,
        remainingBudget: 0
      },
      list: [],
      form: {
        expansionMoney: 0,
        expansionRemark: ""
      }
    };
  },
  computed: {
    id() {
      return this.$route.params.id;
    },
    type() {
      return this.$route.params.type;
    }
  },
  mounted() {
    this.load();
  },
  methods: {
    load() {
      this.$http.get("/api/budget/remaining-info/" + this.id + "/" + this.type).then(a => {
        this.info = a.body;
        this.$http.get("/api/budget/expansion/" + this.id + "/" + this.type).then(a => {
          this.list = a.body;
        });
      });
    },
    formSubmit() {
      if (this.checkForm() == false) return;
      this.$http.post("/api/budget/expansion/" + this.id + "/" + this.type, this.form).then(a => {
        if (a.body.status) {
          alert("新增成功");
          this.form.expansionMoney = 0;
          this.form.expansionRemark = "";
          this.load();
        } else {
          alert(a.body.msg);
          console.log(a.body.exstr);
        }
      });
    },
    checkForm() {
      let msg = "";
      if (this.form.expansionMoney == 0) msg += "『擴充金額』、";
      if (this.form.expansionRemark == "") msg += "『備註說明』、";
      if (msg != "") {
        alert(msg.substr(0, msg.length - 1) + " 尚未填寫");
        return false;
      }
      return true;
    }
  }
};
</script>

<style>
</style>